/** AsyncStorage keys used across the app */
export const ONBOARDING_FLAG_KEY = '@tournaly_show_onboarding';
export const NOTIFICATIONS_PERMISSION_KEY = '@tournaly_notifications_requested';
